import React from "react";
import {
  Card,
  Button,
  Modal,
  MarketingLayout,
  FormField,
  InputArea,
  Layout,
  Cell,
  Loader,
  Notification,
  Divider,
  ColorInput,
  TextButton,
  Heading,
  Text,
  Box,
  Dropdown
} from '@wix/design-system';

import { passCsrfToken } from '../../util/helpers'
import axios from 'axios'

class FrontOffice extends React.Component {
  state = {
    config: this.props.configData,
    loading: false,
    showNotification: false,
    loadingSaveProcess: false,
  };

  componentDidMount = () => {
    passCsrfToken(document, axios);
  }

  handleCopy = (e) => {
    var copyUrl = $("#shopify_plus_name");
    copyUrl.focus();
    copyUrl.select();
    document.execCommand('copy');
    this.props.toggleToast(I18n.t('configs.front_end.copySuccess'), false);
  }

  handleChangeColor = (field, value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [field]: value },
    })
  }

  handleChangeDropdown = (field, option) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [field]: option.id },
    })
  }

  /* Submit FORM */
  handleSubmit = () => {
    this.setState({showNotification: false});
    this.setState({ loadingSaveProcess: true });

    axios({
    url: this.state.config.id ? '/configs/' + this.state.config.id : '/configs',
    method: this.state.config.id ? 'patch' : 'post',
    data: {
      config: this.state.config,
      instance_id: this.props.shop.instance_id
    },
    }).then(result => {
      if (result.data.success == true) {
        var data = result.data;
        data.config.local_offer = Object.keys(JSON.parse(data.config.local_offer));
        this.setState({ config: data.config });
        this.props.childChange(data.config);
        this.setState({loadingSaveProcess: false});
        this.props.handleUpdateConfig(false);
        this.props.toggleToast(I18n.t('configs.save_success'), false);
      } else {
        this.setState({loadingSaveProcess: false});
        this.props.toggleToast(I18n.t('configs.save_error'), true);
      }
    }).catch(error => {
      console.log(error);
      this.setState({loadingSaveProcess: false});
      this.props.toggleToast(I18n.t('configs.save_error'), true);
    });
  };

  render() {
    const {
      config,
      loadingSaveProcess
    } = this.state;

    const appName = config.app_name || 'wix-colissimo';

    return (
      <div class="carrier_page">
        <Modal
          screen="desktop"
          isOpen={loadingSaveProcess}
        >
          <Loader size="large" />
        </Modal>

        {/* SCRIPT D'INTEGRATION */}
        <Layout cols={12}>
          <Cell span={4}>
            <Card>
              <MarketingLayout
                title={I18n.t('configs.front_end.title_pickuppoint')}
                description={I18n.t('configs.front_end.help_text_pickuppoint')}
                actions={<TextButton as="a" href="https://www.loom.com/share/c97a6ba003b4481c97a11a8b68ad96c5?sid=25ed6dca-8eaa-47fe-99ac-a90c07d2e965" target="_blank">{I18n.t('configs.view_video_button')}</TextButton>}
                size="tiny"
              />
            </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <FormField
                    label={I18n.t('configs.front_end.desc_pickuppoint')}
                  >
                    <InputArea
                      id="shopify_plus_name"
                      value={`<script src="//ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="//ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/jquery-ui.min.js"></script>
<script src="//deuzwzipilmzy.cloudfront.net/appcolissimo.js?id=${this.props.shop.instance_id}&cloud=deuzwzipilmzy.cloudfront.net&shop=${this.props.shop.id}&app_name=${appName}"></script>
<script src="//deuzwzipilmzy.cloudfront.net/thankyou.js"></script>
<script src="//deuzwzipilmzy.cloudfront.net/return.js"></script>`}
                      name="widget_endpoint"
                      readOnly
                      rows={6}
                    />
                  </FormField>
                  <br/>
                  <Button size="small" as="button" onClick={() => {this.handleCopy()}}>{I18n.t('configs.front_end.button_copy')}</Button>
                </Cell>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>

        <Divider />

        {/* COULEUR BOUTON CHECKOUT */}
        <Layout cols={12}>
          <Cell span={4}>
            <Card>
              <MarketingLayout
                title={I18n.t('configs.front_end.checkout_button_color')}
                description={I18n.t('configs.front_end.help_checkout_button_color')}
                size="tiny"
              />
            </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <FormField label={I18n.t('configs.front_end.button_color')}>
                    <ColorInput
                      value={config.button_color}
                      onConfirm={(e) => this.handleChangeColor('button_color', e)}
                      popoverAppendTo="viewport"
                    />
                  </FormField>
                  <br/>
                </Cell>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>

        <Divider />

        {/* TYPE DE POINTS RELAIS */}
        <Layout cols={12}>
          <Cell span={4}>
            <Card>
              <MarketingLayout
                title={I18n.t('configs.front_end.filter_relay_title')}
                description={I18n.t('configs.front_end.help_filter_relay')}
                size="tiny"
              />
            </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <FormField label={I18n.t('configs.front_end.label_filter_relay')}>
                    <Dropdown
                      name="filter_relay"
                      options={[
                        {id: '0', value: I18n.t('configs.front_end.filter_relay_0')},
                        {id: '1', value: I18n.t('configs.front_end.filter_relay_1')},
                        {id: '2', value: I18n.t('configs.front_end.filter_relay_2')},
                        {id: '3', value: I18n.t('configs.front_end.filter_relay_3')},
                        {id: '5', value: I18n.t('configs.front_end.filter_relay_5')},
                        {id: '10', value: I18n.t('configs.front_end.filter_relay_10')},
                        {id: '11', value: I18n.t('configs.front_end.filter_relay_11')},
                      ]}
                      onSelect={(option) => this.handleChangeDropdown('filter_relay', option)}
                      selectedId={config.filter_relay || '1'}
                    />
                  </FormField>
                  <br/>
                </Cell>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>

        <Divider />

        {/* APERCU DU WIDGET */}
        <Layout cols={12}>
          <Cell span={4}>
            <Card>
              <MarketingLayout
                title={I18n.t('configs.front_end.example_display') || "Aperçu"}
                description="Voici un aperçu de l'affichage du sélecteur de point relais sur votre checkout."
                size="tiny"
              />
            </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  {/* Preview du widget confirm */}
                  <div style={{border: '1px solid #e5e7eb', borderRadius: '12px 12px 0 0', overflow: 'hidden', maxWidth: '500px'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 20px', background: '#f8fafc', borderBottom: '1px solid #e5e7eb'}}>
                      <img src="https://www.colissimo.fr/favicon.ico" style={{width: '28px', height: '28px', borderRadius: '6px'}} alt="Colissimo" />
                      <div style={{flex: 1}}>
                        <div style={{fontSize: '15px', fontWeight: 700, color: '#1f2937'}}>Point retrait sélectionné</div>
                        <div style={{fontSize: '12px', color: '#6b7280', marginTop: '1px'}}>Colissimo Point Retrait</div>
                      </div>
                      <div style={{
                        background: 'transparent',
                        border: `2px solid ${config.button_color || '#5a7d8f'}`,
                        color: config.button_color || '#5a7d8f',
                        borderRadius: '8px',
                        padding: '6px 14px',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'default'
                      }}>
                        ✎ Modifier
                      </div>
                    </div>
                    <div style={{padding: '16px 20px'}}>
                      <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
                        <div style={{width: '36px', height: '36px', borderRadius: '50%', background: config.button_color || '#5a7d8f', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0}}>📍</div>
                        <div style={{lineHeight: 1.6, color: '#374151', fontSize: '13px'}}>
                          <strong style={{fontSize: '14px'}}>BUREAU DE POSTE EXEMPLE</strong><br/>
                          12 RUE DE LA PAIX<br/>
                          <span style={{color: '#6b7280'}}>75001 PARIS</span><br/>
                          <span style={{color: '#9ca3af', fontSize: '11px'}}>FRANCE</span>
                        </div>
                      </div>
                    </div>
                    <div style={{padding: '14px 20px', borderTop: '1px solid #f3f4f6', background: '#fafafa'}}>
                      <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <span style={{fontSize: '20px'}}>📞</span>
                        <div style={{flex: 1}}>
                          <div style={{fontSize: '12px', color: '#6b7280'}}>Notifications de livraison</div>
                          <div style={{fontSize: '15px', fontWeight: 600, color: '#1f2937'}}>06 12 34 56 78</div>
                        </div>
                        <span style={{color: '#10b981', fontSize: '18px'}}>✓</span>
                      </div>
                    </div>
                  </div>
                </Cell>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>
      </div>
    );
  }
}

export default FrontOffice
